import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { from, of } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-infomodal',
  templateUrl: './infomodal.component.html',
  styleUrls: ['./infomodal.component.scss']
})
export class InfomodalComponent implements OnInit {

  constructor(
    private translateService: TranslateService
  ) { }

  @Input()
  modalDialogBodyContent = 'bodyContent';

  @Input()
  modalDialogBodyType = 'bodyType';

  @Input()
  modalDialogType = 'BLOCK_TOAST';

  @Input()
  timeDelay = 2000;

  @Output() closeSuccessModalDialogEvent = new EventEmitter<boolean>();


  ngOnInit(): void {

    const myArray = [1, 2, 3, 4];
    from(myArray).pipe(
      concatMap(item => of(item).pipe(delay(this.timeDelay)))
    ).subscribe(timedItem => {
      this.closeSuccessModalDialogEvent.emit(true);
    });

  }

  raiseModalEvent(eventAction) {
    if (eventAction === 'close') {
      this.closeSuccessModalDialogEvent.emit(true);
    }
  }

}
